import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Newspaper,
  Megaphone,
  FolderTree,
  Tags,
  MessageSquare,
  Image,
  Users,
  Mail,
  PhoneCall,
  SearchCheck,
  LogOut,
  Building2,
  ShieldCheck,
  Handshake,
} from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { label: "Dashboard", path: "/admin", icon: LayoutDashboard },
  { label: "Posts", path: "/admin/posts", icon: Newspaper },
  { label: "Announcements", path: "/admin/announcements", icon: Megaphone },
  { label: "Categories", path: "/admin/categories", icon: FolderTree },
  { label: "Tags", path: "/admin/tags", icon: Tags },
  { label: "Comments", path: "/admin/comments", icon: MessageSquare },
  { label: "Media Library", path: "/admin/media", icon: Image },
  { label: "Users", path: "/admin/users", icon: Users },
  { label: "Newsletter", path: "/admin/newsletter", icon: Mail },
  // { label: "Contact Messages", path: "/admin/contacts", icon: PhoneCall },
  { label: "SEO Settings", path: "/admin/seo", icon: SearchCheck },
  { label: "Projects", path: "/admin/projects", icon: Building2 },
  { label: "Complaints", path: "/admin/complaints", icon: ShieldCheck },
  { label: "Partnerships", path: "/admin/partnerships", icon: Handshake },
];

const AdminLayout = () => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin-signin");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="hidden lg:flex w-[290px] bg-[#061A40] text-white flex-col fixed inset-y-0 left-0 z-40 shadow-2xl">
        <div className="p-6 border-b border-white/10">
          <img
            src="/assets/images/logo2.png"
            alt="OGFZA"
            className="w-16 h-16 object-contain mb-4"
          />

          <h2 className="font-black leading-tight text-xl">
            OGFZA CMS
          </h2>

          <p className="text-xs text-white/60 mt-2">
            Oil & Gas Free Zones Authority
          </p>

          <div className="mt-3 inline-flex px-3 py-1 rounded-full bg-[#F4B000]/20 text-[#F4B000] text-[11px] font-bold">
            {admin?.role?.toUpperCase()}
          </div>
        </div>

        <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
          {links.map(({ label, path, icon: Icon }) => (
            <NavLink
              key={label}
              to={path}
              end={path === "/admin"}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-2xl font-semibold transition-all duration-200 ${
                  isActive
                    ? "bg-[#F4B000] text-[#061A40] shadow-lg"
                    : "text-white/75 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-3 rounded-2xl bg-white/10 hover:bg-[#F4B000] hover:text-[#061A40] transition-all duration-200 flex items-center gap-3 font-bold"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-[290px]">
        <header className="sticky top-0 z-30 bg-white border-b border-slate-200 px-6 py-4 flex justify-between items-center shadow-sm">
          <div>
            <h1 className="font-black text-[#061A40] text-xl">
              OGFZA Administration
            </h1>

            <p className="text-xs text-slate-500 mt-1">
              Welcome back, {admin?.name}
            </p>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden md:block text-right">
              <p className="font-semibold text-sm text-slate-700">
                {admin?.name}
              </p>
              <p className="text-xs text-slate-500">
                {admin?.role}
              </p>
            </div>

            <div className="w-10 h-10 rounded-full bg-[#061A40] text-white flex items-center justify-center font-bold">
              {admin?.name?.charAt(0)?.toUpperCase()}
            </div>

            <button
              onClick={handleLogout}
              className="lg:hidden px-4 py-2 rounded-xl bg-[#061A40] text-white"
            >
              Logout
            </button>
          </div>
        </header>

        <main className="p-4 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;